import { GROUPS, generate } from "../calculations/calc";
import { getClass } from "../calculations/calculationDivs";

export const DetailDotMap = (props) => {
    const { groupCounts, oldCounts, country, short } = props;
    const counts = GROUPS.map((x, i) => groupCounts.data[i]);

    return (
    <div>
        <div className="flex">
            <div className="dot-country">
                <div className="highlight groupNi"><img src={"flags/" + short.toLowerCase() + ".png"} alt={country} height={12} />&nbsp;{short}</div>
                <div className="highlight">prediction</div>
            </div>
            {GROUPS.slice(0, 7).map((x, i) => DotItem(counts, i))}
        </div>
        <div className="flex">
            <div className="dot-country"><div className="highlight">+/- 2019</div></div>
            {GROUPS.slice(0, 7).map((x, i) => SumItem(counts, i, oldCounts))}
        </div>
        <hr />
    </div>
    )
}

const SumItem = (counts, index, oldCounts) => {
    const diff = counts[index] - oldCounts[index];
    return (
        <div key={index} className="group-column">
            <div className="highlight"><span className="floatRight">{diff > 0 ? "+" : ""}{diff}</span></div>
        </div>
    )
}

const DotItem = (counts, index) => {
    const group = GROUPS[index];
    const className = getClass(group);
    return (
        <div key={index} className="group-column">
            <div className={"highlight " + className}>{group}<span className="floatRight">{counts[index]}</span></div>
            {Dot(counts[index], className)}
        </div>
    )
}

const Dot = (count, group) => {
    return generate(count).map((x, i) => <span key={i} className={"dot " + group} />);
}
